<template>
    <div class="error-task">
        <div class="wrap">
            <div class="question stu_dowork_line"
                 v-for="q in questions">
                <div v-if="showNum"
                     class="q_num">第{{q.no}}题</div>
                <p class="title"
                   v-if="q.type!=8 && q.content">
                    <!--<span class="order">{{number}}</span>-->
                    <span v-html="q.content"></span>
                </p>
                <p class="title"
                   v-else-if="q.type==8 && q.article_text"><span v-html="q.article_text"></span></p>

                <div class="img-wrap"><img :src="q.image"
                         v-if="q.image && q.image.url" /></div>

                <div class="ask"
                     v-for="ask in q.asks">

                    <!-- 选择题 -->
                    <div class="choose"
                         v-if="ask.type==1||ask.type==8||ask.type==7">
                        <choice :ask='ask'
                                :type="ask.type"
                                :mystatus='0'
                                :status="1"></choice>
                    </div>
                    <!-- 填空 -->
                    <div v-if='ask.type == 2'>
                        <blanks :ask='ask'></blanks>
                    </div>
                    <!-- 主观题 -->
                    <div v-if='ask.type == 3'>
                        <!--<subjective :ask='data.asks' :index='inx' :ask='ask' :askLength='data.asks.length'></subjective>-->
                    </div>
                    <!-- 连线题 -->
                    <div class="line"
                         v-if="ask.type==4">
                        <lines :ask='ask'
                               :sheet="ask.right_answer"
                               :onlyshow='false'
                               :askLength='ask.options.length'></lines>
                    </div>
                    <!-- 排序题 -->
                    <div class="line"
                         v-if="ask.type==5">
                        <makes :ask='ask'
                               :is_answer="true"
                               :type='ask.type'></makes>
                    </div>
                    <!-- 断句题 -->
                    <div v-if="ask.type==6">
                        <sentence :ask='ask'></sentence>
                    </div>
                </div>
                <template v-if="type=='task'">
                    <div class="content"
                         v-if="q.wrong_stu_names.length">
                        <div class="title_wrong">答错<span>{{q.wrong_stu_names.length}}</span>人,错误率{{q.wrong_rate}}%</div>
                        <div class="name">
                            <span v-for="name in q.wrong_stu_names">{{name}}</span>
                        </div>
                    </div>
                    <div class="content"
                         v-else>
                        <div class="title_wrong">没有人答错</div>
                    </div>
                </template>
                <template v-else-if="type=='knowledg'">
                    <div class="content"
                         v-if="q.wrong_stu_names.length">
                        <div class="title_wrong">答错<span>{{q.wrong_stu_names.length}}</span>人,错误率{{q.wrong_rate}}%</div>
                        <div class="name">
                            <span v-for="name in q.wrong_stu_names">{{name}}</span>
                        </div>
                    </div>
                    <div class="content"
                         v-else>
                        <div class="title_wrong">没有人答错</div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
/**
 * 1选择，2填空，3判断，4连线，5：排序题，6断句题，7：解答题
 */
import choice from './module/result_choose.vue'  //选择题
import blanks from './module/result_fill.vue'  //填空题
import lines from './module/result_line.vue';     //连线题
import sentence from './module/result_sentence.vue';//断句题
import makes from './module/result_make.vue';//排序题
export default {
    props: ['questions', 'sid', 'type', 'showNum'],
    data () {
        return {
        }
    },
    methods: {
    },
    created () {
        //console.log(this.questions)
    },
    destroyed () {
    },
    components: {
        sentence,
        choice,
        blanks,
        lines,
        makes
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.error-task {
    display: block;
    width: 600px / $ppr;
    padding: 30px / $ppr;
    margin: 0 auto;
    background: #fff;
    margin-top: 30px / $ppr;
    border-radius: 16px / $ppr;
    margin-bottom: 30px / $ppr;
}
.q_num {
    line-height: 46px / $ppr;
    font-size: 28px / $ppr;
    font-weight: bold;
    padding: 0 0 16px / $ppr;
}
.content {
    background-color: #fff;
    .title {
        height: 82px / $ppr;
        line-height: 82px / $ppr;
        font-size: 28px / $ppr;
        padding: 0 24px / $ppr;
    }
    .title_wrong {
        height: 82px / $ppr;
        line-height: 82px / $ppr;
        font-size: 30px / $ppr;
    }
    .name {
        padding: 24px / $ppr 24px / $ppr;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        // min-height: 200px/$ppr;
        span {
            width: 30%;
            font-size: 28px / $ppr;
            color: #333;
            margin: 12px / $ppr 0;
            @include ellipsis;
        }
    }
}

.question {
    // font-family:Monospace;
    margin-bottom: 24px / $ppr;
    .order {
        color: #5e89ef;
    }
    .title {
        background-color: #fff;
        //border-bottom: 1px/$ppr solid #E8E8E8;
        padding: 24px / $ppr 24px / $ppr;
    }
    .img-wrap {
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        justify-content: center;
        -webkit-justify-content: center;
        img {
            display: inline-block;
        }
    }
    .ask {
        margin-bottom: 24px / $ppr;
        background-color: #fff;
    }
    .subtitle-wrap {
        border-bottom: 1px / $ppr solid #e8e8e8;
    }
    .subtitle {
        padding: 24px / $ppr 24px / $ppr;
    }
    .option {
        padding: 24px / $ppr 24px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        .spot {
            display: block;
            width: 24px / $ppr * 2;
            height: 24px / $ppr * 2;
            line-height: 24px / $ppr * 2;
            text-align: center;
            border: 1px / $ppr solid #e8e8e8;
            border-radius: 24px / $ppr;
            margin-right: 24px / $ppr;
        }
    }
    .checked {
        color: #66cc22 !important;
        .spot {
            background-color: #66cc22 !important;
            border: 1px / $ppr solid #66cc22 !important;
            color: #fff;
        }
    }
}

.question .option:last-child {
    border: 0 !important;
}
</style>
